var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-container"},[_c('Header'),_c('AppMain'),_c('Footer'),(_vm.$store.getters.agreements.length>0)?_c('PrivacyPolicyPopup',{ref:"policyPopup"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }